import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
export const TruncatedText = t0 => {
  const $ = _c(10);
  const {
    children,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const element = textRef.current;
      if (!element) {
        return;
      }
      const checkTruncation = () => {
        setIsTruncated(element.scrollWidth > element.clientWidth);
      };
      const observer = new ResizeObserver(checkTruncation);
      observer.observe(element);
      checkTruncation();
      return () => observer.disconnect();
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  const t4 = !isTruncated;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      tooltip: "max-w-[min(40em,90vw)]"
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = `truncate text-nowrap ${className}`;
  let t7;
  if ($[3] !== children || $[4] !== t6) {
    t7 = <div ref={textRef} className={t6}>{children}</div>;
    $[3] = children;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== children || $[7] !== t4 || $[8] !== t7) {
    t8 = <Tooltip disabled={t4} label={children} classNames={t5}>{t7}</Tooltip>;
    $[6] = children;
    $[7] = t4;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};